import api from '../api/axiosConfig';
import type {
  BillingAuthIssueRequest,
  BillingAuthIssueResponse,
  PaymentDto,
  PaymentHistoryResponseDto,
  SubscriptionStatusDto,
} from '../types/userTypes';

export const getPaymentHistory = async (): Promise<PaymentDto[]> => {
  const {data} = await api.get<PaymentHistoryResponseDto | PaymentDto[]>('/payment/history');

  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data?.items)) {
    return data.items;
  }
  if (Array.isArray((data as any)?.payments)) {
    return (data as any).payments;
  }
  if (Array.isArray((data as any)?.list)) {
    return (data as any).list;
  }
  if (Array.isArray((data as any)?.data)) {
    return (data as any).data;
  }
  return [];
};

export const getSubscriptionStatus = async (): Promise<SubscriptionStatusDto> => {
  const {data} = await api.get<SubscriptionStatusDto>('/billing/subscription-status');
  return data;
};

export const issueBillingKey = async (
    request: BillingAuthIssueRequest,
): Promise<BillingAuthIssueResponse> => {
  const {data} = await api.post<BillingAuthIssueResponse>(
      '/billing/billing-key/issue',
      request,
  );
  return data;
};

export const cancelSubscription = async (): Promise<void> => {
  await api.post('/billing/cancel');
};

export const reactivateSubscription = async (): Promise<void> => {
  await api.post('/billing/reactivate');
};
